import React, { useEffect } from 'react';
import { Col, Container, Row, Button } from 'reactstrap';
import { reactGAPageview, reactGAEvent } from '../../helper';
import { defaultFlow } from '../../redux/initialState';
import selectedFinancierEnum from '../../assets/js/SelectedFinancierEnum';
import { connect } from 'react-redux';
import { changePage } from '../../redux/actions';
import { AquaPreQualificationFlowPageNumber } from '../PreQualification/preQualificationFlow';

const Declined = props => {
  const {
    email,
    dealerUserId,
    did,
    consumerToken,
    history,
    wellsFargoInformation,
    dispatchSetFlow,
    dispatchSubmitMindfire,
    dispatchUpdateSelectedFinancier,
    dispatchMapWellsFargoToMicrof,
    isConsumer,
    dispatchChangePage,
  } = props;

  useEffect(() => {
    reactGAPageview({
      path: '/wf_declined',
      trackerNames: [],
      title: 'wf_declined',
      did,
      dealerUserId,
    });
    // eslint-disable-next-line
  }, []);

  const handleClick = async () => {
    reactGAEvent({
      category: 'Button',
      action: 'Click',
      label: 'Continue to Microf',
      did,
      dealerUserId,
    });
    dispatchSubmitMindfire({
      email: email,
      lastPage: '5013',
      dealerUserId: dealerUserId,
      did: did,
    });
    await dispatchUpdateSelectedFinancier(selectedFinancierEnum.MICROF.value, consumerToken, () => {
      dispatchMapWellsFargoToMicrof(wellsFargoInformation);
      dispatchSetFlow(defaultFlow);
      dispatchChangePage(AquaPreQualificationFlowPageNumber.UserLastInfo);
      history.push('/');
    });
  };

  return (
    <Container>
      <Row className="justify-content-center mt-2">
        <Col xs="auto" sm="8" className="text-center">
          <h5>
            <b>
              Wells Fargo was unable to approve your credit application at this time. You will
              receive written notification in the mail within 30 days.
            </b>
          </h5>
        </Col>
      </Row>
      <Row className="justify-content-center mt-2">
        <Col xs="auto" sm="8" className="text-center">
          <h5>
            <b>
              But Wait! You may still qualify for a lease purchase option. A lease purchase option
              is different than financing.
            </b>
          </h5>
        </Col>
      </Row>

      <>
        <Row className="justify-content-center ">
          <Col className="text-center">
            <h3>Microf Lease Purchase Option</h3>
          </Col>
        </Row>
        <Row className="justify-content-center ">
          <Col xs="auto" sm="8">
            <ul className="microf-lease-purchase-options">
              <li>
                Monthly renewals up to 84 months to own.{' '}
                <p>Not all term options are available in all states.</p>
              </li>
              <li>
                You will own the item after the total of payments to ownership is paid in full or is
                paid by prepayment.{' '}
                <p>
                  Save up to 40% or more off your remaining payments to ownership. Early Purchase
                  Options vary by state, so call us at 855-642-7631 for details.
                </p>
              </li>
              <li>
                Damaged credit? Not a problem!{' '}
                <p>Microf regularly approves applicants with less than perfect credit.</p>
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="justify-content-center mt-5">
          <Col xs="auto" sm="8">
            <h6>
              Applicants will be ineligible if: (1) the home is on rented land (e.g., mobile home
              park), (2) the home is in a reverse mortgage, or (3) the home is rent/lease-to-own.
            </h6>
          </Col>
        </Row>
      </>

      <Row className="mt-3 justify-content-center">
        <Col xs="12" md="auto">
          <Button color="primary" onClick={handleClick}>
            {isConsumer ? 'Apply Now' : 'Continue to Microf'}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  dispatchChangePage: page => dispatch(changePage(page)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Declined);
